<div class="hint-group">
  @for (hint of hints; track $index) {
    @let isActive = hint.test(password());
    <div class="hint">
      <app-icon
        class="hint__icon"
        [icon]="isActive ? iconName.PASSWORD_HINT_CHECK : iconName.PASSWORD_HINT_CROSS"
      />
      <span [ngClass]="'hint__' + (isActive ? 'active' : 'inactive')">
        {{ hint.translateKey | translate }}
      </span>
    </div>
  }
</div>
